import React from 'react';

import { styled, useTheme } from '@mui/system';
import { alpha } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import { IndicatorTagT } from 'routes/Indicators/helpers/types';
import { getChipLabel } from './helpers';
import { getChipColorFromIndicatorTag } from '../../helpers/helpers';

const StyChip = styled(Chip, {
    shouldForwardProp: (prop) => prop !== 'chipColor',
})<{ chipColor: string }>(({ chipColor }) => ({
    backgroundColor: alpha(chipColor, 0.2),
    borderWidth: '0',
    color: chipColor,
}));

const IndicatorTag = ({
    indicatorTag,
}: {
    indicatorTag: IndicatorTagT;
}): JSX.Element => {
    const theme = useTheme();

    const { type, value, aggregation } = indicatorTag;
    if (!value) return <></>;

    const { isTruncated, chipLabel } = getChipLabel(value, aggregation);
    const chipColor = getChipColorFromIndicatorTag(type, theme);

    return (
        <Tooltip enterDelay={500} title={isTruncated ? value : undefined}>
            <StyChip
                chipColor={chipColor}
                label={chipLabel}
                size="small"
                variant="outlined"
            />
        </Tooltip>
    );
};

export default IndicatorTag;
